import { useEffect, useState } from 'react';
import './App.css';
import SurahCard from './SurahCard';
import {
  Button,
  Dialog,
  Card,
  CardBody,
  CardFooter,
  Typography,
  Input,
  ThemeProvider,
} from "@material-tailwind/react";

function App() {
  const [data, setData] = useState([]);
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen((cur) => !cur);
  const [surah, setSurah] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_LINK}?name=Sheet1`
        );
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        const result = await response.json();
        setData(result);
      } catch (err) {
        console.log(err.message);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    if (data.length > 0) {
      setLoading(false);
    }
  }
  , [data]);

  const handleChange = (e) => {
    setSurah(e.target.value);
  }

  const handleSubmit = async () => {
    const date = new Date();
    const day = date.getDate();
    const month = date.getMonth() + 1;
    const year = date.getFullYear();
    const formattedDate = `${month}/${day}/${year}`;
    try {
      const response = await fetch(process.env.REACT_APP_API_LINK, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        mode: "no-cors",
        body: JSON.stringify({ action: "add", surah: surah, last_date: formattedDate }),
      });
      setSurah("");
      setData((cur) => [...cur, { surah: surah, last_date: formattedDate, tekrar: 1}]);
      handleOpen();
      const result = await response.json();
      if (result.error) {
        throw new Error(result.error);
      }
      console.log("Data added successfully!");
    } catch (error) {
      console.log(`Error: ${error.message}`);
    }
  };

  const cards = data.map((item, index) => (
    <SurahCard key={index} surah={item.surah} date={item.last_date} tekrar={item.tekrar} />
  ));

  return (
    <ThemeProvider>
    <div className="App">
      <div className="bg-gradient-to-bl from-blue-50 to-violet-50 flex items-center justify-center lg:h-screen">
        <div className="container mx-auto mx-auto p-4">
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-4 xl:grid-cols-4 gap-4">
            {loading ? 
              <div className="bg-white rounded-xl border p-4">
                <div className="animate-pulse flex flex-col gap-4">
                  <div className="h-4 bg-gray-200 rounded w-1/2"></div>
                  <div className="h-4 bg-gray-200 rounded w-1/4"></div>
                  <div className="h-4 bg-gray-200 rounded w-1/3"></div>
                </div>
              </div>
              :
              <>{cards}</>
            }
            <div className="bg-white rounded-xl border p-4 hover:bg-blue-200" onClick={handleOpen}>
              <div className="px-1 py-4">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-40 ml-auto mr-auto mt-7 mb-auto">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M12 4.5v15m7.5-7.5h-15" />
                </svg>
              </div>
            </div>
            <Dialog
              size="xs"
              open={open}
              handler={handleOpen}
              className="bg-transparent shadow-none"
            >
              <Card className="mx-auto w-full max-w-[24rem]">
                <CardBody className="flex flex-col gap-4">
                  <Typography variant="h4" color="blue-gray">
                    Add new surah
                  </Typography>
                  <Typography className="-mb-2" variant="h6">
                    Surah Name
                  </Typography>
                  <Input size="lg" value={surah} onChange={handleChange}/>
                </CardBody>
                <CardFooter className="pt-0">
                  <Button variant="gradient" onClick={handleSubmit} fullWidth>
                    Submit
                  </Button>
                </CardFooter>
              </Card>
            </Dialog>
          </div>
        </div>
      </div>
    </div>
    </ThemeProvider>
  );
}

export default App;

